// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button_Button_27iTr","Success":"Button_Success_2Vddq","Danger":"Button_Danger_2ffsZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Button/Button.css
// module id = 144
// module chunks = 3